import React, {FC, useMemo} from 'react';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";

export const BookmarksFillIcon: FC = () => {

    const is1440BP = useBreakpoint(LayoutConst.screen.mac13);
    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

    if (!is1440BP && !smHeight) return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.1001 9.70598C7.1001 7.22942 8.97343 5.1001 11.4287 5.1001H20.5715C23.0268 5.1001 24.9001 7.22942 24.9001 9.70598V29.1462L16.0001 20.4009L7.1001 29.1462V9.70598Z" fill="auto"/>
    </svg>

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M4.5 6.17647C4.5 4.17332 6.04046 2.5 8 2.5H16C17.9595 2.5 19.5 4.17332 19.5 6.17647V22.1753L12 14.956L4.5 22.1753V6.17647Z" fill="auto"/>
        </svg>
    )
}
import React, {FC, useMemo} from 'react';
import {useBreakpoint} from "@brg/ui";
import {LayoutConst} from "../../../core";

export const BookmarksFillIcon: FC = () => {

    const is1440BP = useBreakpoint(LayoutConst.screen.mac13);
    const smHeight = useMemo(() => (window.innerHeight < LayoutConst.screen.height.projectCover), []);

    if (!is1440BP && !smHeight) return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.1001 9.70598C7.1001 7.22942 8.97343 5.1001 11.4287 5.1001H20.5715C23.0268 5.1001 24.9001 7.22942 24.9001 9.70598V29.1462L16.0001 20.4009L7.1001 29.1462V9.70598Z" fill="auto"/>
    </svg>

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M4.5 6.17647C4.5 4.17332 6.04046 2.5 8 2.5H16C17.9595 2.5 19.5 4.17332 19.5 6.17647V22.1753L12 14.956L4.5 22.1753V6.17647Z" fill="auto"/>
        </svg>
    )
}
